"use strict";

function DOMready(callback) {
  if (document.readyState != "loading") callback();
  else document.addEventListener("DOMContentLoaded", callback);
}

// Load generic JS. Also reinitializes when sections are
// added, edited, or removed in Shopify's editor
theme.initGlobals = function () {
  theme.collapsibles.init();
  theme.videoModal();
  theme.lazyImages();
};

DOMready(function () {
  theme.sections = new theme.Sections();

  theme.sections.register("slideshow-section", theme.SlideshowSection);
  theme.sections.register("header", theme.HeaderSection);
  theme.sections.register("product", theme.Product);
  theme.sections.register("blog", theme.Blog);
  theme.sections.register("password-header", theme.PasswordHeader);
  theme.sections.register("photoswipe", theme.Photoswipe);
  theme.sections.register("product-recommendations", theme.Recommendations);
  theme.sections.register("background-image", theme.BackgroundImage);
  theme.sections.register("testimonials", theme.Testimonials);
  theme.sections.register("video-section", theme.VideoSection);
  theme.sections.register("map", theme.Maps);
  theme.sections.register("footer-section", theme.FooterSection);
  theme.sections.register("store-availability", theme.StoreAvailability);
  theme.sections.register("recently-viewed", theme.RecentlyViewed);
  theme.sections.register("newsletter-popup", theme.NewsletterPopup);
  theme.sections.register("collection-header", theme.CollectionHeader);
  theme.sections.register("collection-grid", theme.Collection);
  theme.sections.register("shoppable-image-section", theme.ShoppableImage);

  theme.initGlobals();
  theme.initQuickShop();
  theme.rteInit();

  if (document.body.classList.contains("template-cart")) {
    var cartPageForm = document.getElementById("CartPageForm");
    if (cartPageForm) {
      new theme.CartForm(cartPageForm);
    }
  }

  if (theme.settings.predictiveSearch) {
    theme.predictiveSearch.init();
  }

  if (theme.settings.isCustomerTemplate) {
    theme.customerTemplates();
  }

  document.dispatchEvent(new CustomEvent("page:loaded"));
});
